import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.search";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '@/services/apiService';
import MapViewMixin from '@/components/core/dtwin/map/viewMixin';
import { mapState } from 'vuex';
export default {
  name: 'ViewISHeatMonitoringMeterPointMap',
  mixins: [MapViewMixin],
  data: function data() {
    return {
      searchItems: [],
      selectedAccounts: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), {}, {
    requestFilter: function requestFilter() {
      if (this.selectedAccounts.length === 0) {
        return [];
      }

      return [{
        type: 'tenantIds',
        ids: this.selectedAccounts
      }];
    },
    healthStateItems: function healthStateItems() {
      return [// NOTE: a more appropriate value would be `undefined` per default, but
      // that will not match in the v-select with this entry
      // { value: 'disabled', text: `(${this.$i18n_t('DigitalTwin.DigitalTwin.twinDisabled')})` },
      {
        value: '0',
        text: this.$i18n_t('NiotaClassic.DeviceMonitoring.ok')
      }, {
        value: '1',
        text: this.$i18n_t('NiotaClassic.DeviceMonitoring.warning')
      }, {
        value: '2',
        text: this.$i18n_t('NiotaClassic.DeviceMonitoring.alert')
      }, {
        value: '3',
        text: this.$i18n_t('NiotaClassic.DeviceMonitoring.unknown')
      }];
    },
    querySearchItems: function querySearchItems() {
      if (this.searchItems && this.searchItems.length) {
        return this.searchItems.map(function (si) {
          return {
            variable: si.param,
            // support item.search.value === null, so do not simply have a >search.value || search< expression
            search: (si.search || {}).value === undefined ? si.search : si.search.value,
            key: si.key
          };
        });
      }

      return null;
    },
    searchTypes: function searchTypes() {
      return [{
        text: this.$i18n_t('IS.HeatMonitoring.meterPointId'),
        param: 'id'
      }, {
        text: this.$i18n_t('IS.HeatMonitoring.customerId'),
        param: 'customerId'
      }, {
        text: this.$i18n_t('IS.HeatMonitoring.meterId'),
        param: 'meterId'
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props.health'),
        param: 'health',
        items: []
      }];
    }
  }),
  watch: {
    language: function language() {
      (this.searchTypes.find(function (item) {
        return item.param === 'health';
      }) || {}).items = this.healthStateItems;
    },
    selectedAccounts: function selectedAccounts() {
      this.$refs.mapInstance.debouncedRequestClusterRequest();
    },
    searchItems: function searchItems() {
      this.persistMapSettingValue('searchItems', JSON.stringify(this.searchItems));
    }
  },
  mounted: function mounted() {
    (this.searchTypes.find(function (item) {
      return item.param === 'health';
    }) || {}).items = this.healthStateItems;

    try {
      this.searchItems = JSON.parse(localStorage.getItem('map_searchItems')) || [];
    } catch (e) {
      this.searchItems = [];
    }

    this.loadInitialData();
  },
  methods: {
    fetchTwinData: function fetchTwinData() {
      var _this = this;

      this.loadTree();
      return ApiService.isHeatMonitoringFetchGeoMetaInfos(this, this.requestFilter).then(function (data) {
        _this.stateKeys = data.keyList;
        _this.floorList = data.floorList;
      }).catch(function (error) {
        console.error('Error loading map-twin-state-keys', error);
      });
    },
    resetDefaults: function resetDefaults() {
      this.selectedStateKey = null;
      this.searchItems = [];
      this.gradientPolygonColours = false;
      this.selectedAccounts = [];
    },
    valuesToPersist: function valuesToPersist() {
      return {
        gradientPolygonColours: this.gradientPolygonColours,
        excludeZones: this.excludeZones,
        selectedStateKey: this.selectedStateKey,
        searchItems: JSON.stringify(this.searchItems)
      };
    },
    searchUpdated: function searchUpdated(search) {
      this.searchItems = search;
      this.$refs.mapInstance.debouncedRequestClusterRequest();
    },
    getClusterContent: function getClusterContent(cluster, bounds) {
      var _this2 = this;

      if (!cluster) {
        this.selectedCluster = {};
        return;
      }

      ApiService.isHeatMonitoringGetGeoClusterContent(this, cluster.id, this.indoorFloorDtwinId, [[bounds['_ne'].lng, bounds['_ne'].lat], [bounds['_sw'].lng, bounds['_sw'].lat]], this.querySearchItems, // search-items
      this.requestFilter, // filters
      [] // options
      ).then(function (data) {
        _this2.selectedCluster = _objectSpread(_objectSpread({}, cluster), {}, {
          items: data.meterpoints
        });
      }).catch(function (error) {
        console.error('Error loading map-twin-clusters', error);
      });
    },
    loadTree: function loadTree() {
      var _this3 = this;

      var bounds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      return ApiService.isHeatMonitoringFetchGeoClusters(this, this.indoorFloorDtwinId, bounds, this.querySearchItems, // search-items
      this.requestFilter, // filters
      [], // options
      this.selectedStateKey).then(function (data) {
        _this3.calculateBoundingBox(data);

        _this3.markerItems = data.meterpoints;
      }).catch(function (error) {
        console.error('Error loading map-twin-clusters', error);
      }).finally(function () {
        _this3.$store.state.app.loading = false;
      });
    }
  }
};